<template>
  <component :is="resolveLayout">
    <router-view></router-view>
  </component>
</template>

<script>
import { computed, getCurrentInstance } from 'vue'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'

export default {
  components: { LayoutBlank, LayoutContent },
  setup() {
    const inst = getCurrentInstance()
    const proxy = inst.proxy

    const resolveLayout = computed(() => {
      const route = proxy.$route    // access inside computed
      if (!route || !route.name) return null
      return route.meta.layout === 'blank' ? LayoutBlank : LayoutContent
    })

    return { resolveLayout }
  },
}
</script>
